export const formatNumDecimalPoint = (num, decimals) => {
  return num.toFixed(decimals);
};
